import { AxiosResponse } from 'axios';
import ApiUrls from '../config/ApiUrls';
import { replaceByObject } from '../utils/Urls';
import API from './Api';

export type NotificationApiResponse = {
  id: number;
  type: string;
  unread: boolean;
  created: string;
  metadata: {
    calculationId?: number;
    from_entity_id?: string;
    to_entity_id?: string;
  };
};

export class NotificationApi extends API {
  static getGroupNotifications(
    groupId: number
  ): Promise<NotificationApiResponse[]> {
    return API.get(replaceByObject(ApiUrls.Notifications, { groupId })).then(
      (response: AxiosResponse<NotificationApiResponse[]>) => response.data
    );
  }

  static editUnreadStatus(groupId: number, notificationId: number): Promise<NotificationApiResponse> {
    return API.post(
      replaceByObject(ApiUrls.NotificationsPosting, {
        groupId,
        notificationId,
      }),
      {}
    ).then((response: AxiosResponse<NotificationApiResponse>) => response.data);
  }
}
